import classNames from 'classnames';
import styles from './ScoreLabel.module.scss';

const TierLabel = ({ score, tier }) => {
  if (score === 0) return '';
  switch (tier) {
    case 1:
      return 'Experienced';
    case 2:
      return 'Advanced';
    case 3:
      return 'Distinguished';
    case 4:
      return 'Elite';
    default:
      return '';
  }
};

const ScoreLabel = ({ score, showScore, tierAlign, codingName, classes = { label: '' } }) => {
  if (!score || score < 0 || showScore === false) return null;

  const tier = Math.min(Math.floor(score / 25) + 1, 4);

  return (
    <div className={classNames(styles.label, styles.short, styles[`tier-${tier}`], tierAlign ? styles[tierAlign] : '', classes.label)}>
      <TierLabel score={score} tier={tier} />
      {codingName && <> in {codingName}</>}
    </div>
  );
};

export { ScoreLabel as default, ScoreLabel };
